import { INFINITY_ADDON_CONFIG_KEY, TLiftSettingsInfinityAddonConfig } from '@llws/platform-shared-types/types/db/lift';
import app from '@/main';

export const getCurrentClientInfinityAddonConfig = (
  clientId?: number | string,
): TLiftSettingsInfinityAddonConfig | null => {
  const currentUser = app()?.$rsGlobals?.$currentUser;

  if (!currentUser || (clientId !== undefined && `${currentUser.currentClientId}` !== `${clientId}`)) {
    return null;
  }

  const settingValue = currentUser.getClientSettingValue(INFINITY_ADDON_CONFIG_KEY);

  if (settingValue === -1) {
    return null;
  }

  try {
    return typeof settingValue === 'string'
      ? JSON.parse(settingValue) as TLiftSettingsInfinityAddonConfig
      : settingValue;
  } catch (err) {
    console.error('Failed to parse Infinity addon config setting:', err);
    return null;
  }
};
